export default __webpack_public_path__ + "static/subcat-d102176fc24cd77529ee6c8b80db54d5.png";